import { IFilterFacet } from "../interfaces/interfaces";

const ontologySchema = "DirectoryOntologies/graphql";

/** Default filter facets; defaults target the isidore-acc-v13 model
 * (provider-level and service-level columns, no collections). */
export const initialFilterFacets: IFilterFacet[] = [
  {
    facetTitle: "Countries",
    facetIdentifier: "Countries",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "Countries",
    applyToColumn: "country.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    removeOptions: [],
    showMatchTypeSelector: false,
    negotiatorRequestString: "Countries:",
    adaptive: false,
    sortColumn: "label",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Services type",
    facetIdentifier: "Servicestype",
    component: "ServiceFilter",
    sourceSchema: ontologySchema,
    sourceTable: "ServiceTypes",
    applyToColumn: "services.serviceTypes.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    extraAttributes: ["serviceCategory.name", "serviceCategory.label"],
    negotiatorRequestString: "Service Provider services:",
    sortColumn: "name",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "TRL",
    facetIdentifier: "TRL",
    component: "CheckboxFilter",
    sourceSchema: ontologySchema,
    sourceTable: "TRLs",
    applyToColumn: "services.tRL.name",
    filterValueAttribute: "name",
    filterLabelAttribute: "label",
    showMatchTypeSelector: false,
    negotiatorRequestString: "TRL(s):",
    sortColumn: "order",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Collaboration type",
    facetIdentifier: "Collaborationtype",
    component: "ToggleFilter",
    applyToColumn: "collaboration_commercial",
    showMatchTypeSelector: false,
    trueOption: {
      text: "Available to commercial use",
      value: true,
    },
    negotiatorRequestString: "Available to commercial use",
    showFacet: true,
  },
  {
    facetTitle: "Unit theme",
    facetIdentifier: "UnitTheme",
    component: "CheckboxFilter",
    sourceTable: "Services",
    optionsFromGroupBy: true,
    applyToColumn: "services.unitTheme",
    showMatchTypeSelector: false,
    negotiatorRequestString: "Unit theme(s):",
    sortColumn: "unitTheme",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Research Infrastructure",
    facetIdentifier: "ResearchInfrastructure",
    component: "CheckboxFilter",
    sourceTable: "ServiceProviders",
    optionsFromGroupBy: true,
    applyToColumn: "research_infrastructure",
    showMatchTypeSelector: false,
    negotiatorRequestString: "Research Infrastructure(s):",
    sortColumn: "research_infrastructure",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "Network",
    facetIdentifier: "Network",
    component: "CheckboxFilter",
    sourceTable: "Networks",
    applyToColumn: "network.id",
    filterValueAttribute: "id",
    filterLabelAttribute: "name",
    negotiatorRequestString: "Network(s):",
    sortColumn: "name",
    sortDirection: "asc",
    showFacet: true,
  },
  {
    facetTitle: "search",
    facetIdentifier: "search",
    component: "StringFilter",
    negotiatorRequestString: "Text search is",
    builtIn: true /** search should not be generated */,
  },
];
